import React from 'react';
import styled from 'styled-components';
import {Button} from '@betareader/design-system';
import {withTranslation} from 'react-i18next';

import GenreGetter from '../user/userProfileBuilder/fields/genresGetter';
import LanguageGetter from '../user/userProfileBuilder/fields/languages';

const Row = styled.li`
  border-bottom: 1px solid var(--br-border);
  display: grid;
  gap: var(--br-space-3);
  padding: var(--br-space-3) 0;
`;

const Controls = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--br-space-2);
`;

const Select = styled.select`
  background: var(--br-surface);
  border: 1px solid var(--br-border);
  border-radius: var(--br-control-radius);
  color: var(--br-text);
  min-height: 40px;
  padding: 0 var(--br-space-2);
`;

export class ReaderIndexFilter extends React.Component {
  handleReaderFilterTypeChange = newType => {
    const {index} = this.props;
    this.props.handleFilterChange({
      type: newType,
      option: newType === 'rating' ? 'gte' : 'in',
      value: newType === 'rating' ? 0 : [],
      index,
    });
  };

  handleReaderFilterOptionChange = newOption => {
    const {type, value, index} = this.props;
    this.props.handleFilterChange({type, option: newOption, value: value || [], index});
  };

  handleReaderFilterValueChange = newValue => {
    const {type, option, index} = this.props;
    this.props.handleFilterChange({type, option, value: newValue, index});
  };

  render() {
    const {t, addFilter, removeFilter, type, option, value, index} = this.props;
    const hasValue = Array.isArray(value) ? value.length > 0 : Number(value) > 0;
    return (
      <Row>
        <Controls>
          <label htmlFor={`reader-filter-type-${index}`}>{t('SelectFilter')}</label>
          <Select
            id={`reader-filter-type-${index}`}
            value={type || 'any'}
            onChange={event => this.handleReaderFilterTypeChange(event.target.value)}>
            <option value='any'>{t('SelectFilter')}</option>
            <option value='genres'>{t('Genres')}</option>
            <option value='language'>{t('Language')}</option>
            <option value='rating'>{t('Rating')}</option>
          </Select>
          {(type === 'genres' || type === 'language') && (
            <>
              <label htmlFor={`reader-filter-operator-${index}`}>{t('FilterOperator')}</label>
              <Select
                id={`reader-filter-operator-${index}`}
                value={option || 'in'}
                onChange={event => this.handleReaderFilterOptionChange(event.target.value)}>
                <option value='in'>{t('Includes')}</option>
                <option value='nin'>{t('DoesNotInclude')}</option>
                <option value='and'>{t('IncludesAll')}</option>
              </Select>
            </>
          )}
        </Controls>
        {type === 'genres' && (
          <GenreGetter
            header={t('Genres')}
            subheader=' '
            initialValue={value || []}
            autoUpdate
            hideHeader
            dropDown
            onUpdate={this.handleReaderFilterValueChange}
            hideSaveButton
          />
        )}
        {type === 'language' && (
          <LanguageGetter
            header={t('Languages')}
            subheader=' '
            autoUpdate
            compact
            initialValue={value || []}
            onUpdate={selectedLanguageValues => this.handleReaderFilterValueChange(selectedLanguageValues)}
          />
        )}
        {type === 'rating' && (
          <fieldset>
            <legend>{t('AtLeast')}</legend>
            <Controls>
              {[1, 2, 3, 4, 5].map(rating => (
                <Button
                  key={rating}
                  type='button'
                  variant='secondary'
                  size='small'
                  aria-pressed={Number(value) === rating}
                  onClick={() => this.handleReaderFilterValueChange(rating)}>
                  {t('StarsOrMore', {count: rating})}
                </Button>
              ))}
            </Controls>
          </fieldset>
        )}
        <Controls>
          <Button type='button' variant='secondary' size='small' onClick={() => removeFilter(index)}>
            {t('RemoveFilter')}
          </Button>
          <Button type='button' variant='secondary' size='small' disabled={!hasValue} onClick={() => addFilter(index)}>
            {t('AddFilter')}
          </Button>
        </Controls>
      </Row>
    );
  }
}

export default withTranslation()(ReaderIndexFilter);
